module.exports = __webpack_public_path__ + "static/media/WebText_Battle_2.cfd5f171.png";